import { hen, Hen } from "libLegacy/internal/store";

interface NotificationMessage {
  status: string;
  message: string;
  temporary?: boolean;
  actions?: NotificationActions[];
}

type NotificationActions = {
  url: string;
  name: string;
  prefix?: string;
  suffix?: string;
};

export type InitialState = {
  sections: { [key: string]: Array<NotificationMessage> };
};

// Reducers
const initialState: InitialState = {
  sections: {},
};

class NotificationSlice extends Hen<InitialState> {
  firstDismissed(section: string) {
    this.state.sections[section]?.shift?.();
  }

  allDismissed(section: string) {
    this.state.sections[section] = [];
  }

  oneAdded(section: string, m: NotificationMessage) {
    this.state.sections[section] = this.state.sections[section] || [];
    this.state.sections[section].push(m);
  }
}

export const [noteReducer, actions] = hen(new NotificationSlice(initialState));

// Actions

export function dismissAllNotificationsFrom(section: string) {
  return actions.allDismissed(section);
}

export function newNotification(section: string, note: NotificationMessage) {
  return actions.oneAdded(section, note);
}
